module.exports = __webpack_public_path__ + "img/almira.8cc7293.webp";